import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import { User } from '@/types';
import firebase from '@/plugins/firebase';

export interface authState {
  user: User | null;
}

@Module({ namespaced: true, name: 'auth' })
export default class Auth extends VuexModule implements authState {
  user: User | null = null;

  @Mutation SET_USER(user: User) {
    this.user = user;
  }

  get currentUser(): User | null {
    return this.user;
  }

  get currentUserUid(): string | null {
    if (!this.user) return null;
    return this.user.uid;
  }

  @Action({ commit: 'SET_USER' })
  public setUser(payload: { user: User | null; }) {
    if (!payload.user) return null;
    const uid = payload.user.uid;
    //firebase.firestore().collection('users').doc(uid).set(payload.user, {merge: true})
    return payload.user;
  }

  @Action({ commit: 'SET_USER' })
  public async signInWithGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    const credential = await firebase.auth().signInWithPopup(provider);
    // const userInfo: firebase.User | null = credential.user
    // if (!userInfo) return
    // const user: User = {
    //   uid: userInfo.uid,
    //   name: userInfo.displayName,
    //   avatar: userInfo.photoURL,
    //   providerData: userInfo.providerData,
    //   metadata: userInfo.metadata
    // }
    // return user
  }

  @Action({ commit: 'SET_USER' })
  async signInWithFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    const credential = await firebase.auth().signInWithPopup(provider);
    // const userInfo: firebase.User | null = credential.user
    // console.log(userInfo)
    // if (!userInfo) return
    // const user: User = {
    //   uid: userInfo.uid,
    //   name: userInfo.displayName,
    //   avatar: userInfo.photoURL,
    //   providerData: userInfo.providerData,
    //   metadata: userInfo.metadata
    // }
    // return user
  }

  @Action({ commit: 'SET_USER' })
  async signInWithTwitter() {
    const provider = new firebase.auth.TwitterAuthProvider();
    const credential = await firebase.auth().signInWithPopup(provider);
    // const userInfo: firebase.User | null = credential.user
    // if (!userInfo) return
    // const user: User = {
    //   uid: userInfo.uid,
    //   name: userInfo.displayName,
    //   avatar: userInfo.photoURL,
    //   providerData: userInfo.providerData,
    //   metadata: userInfo.metadata
    // }
    // return user
  }



  @Action({ commit: 'SET_USER' })
  async signOut() {
    await firebase.auth().signOut();
    return null;
  }

}